let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kMGo6")).then(() => parcelRequire('46KFl'));